import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import PlayerStore from "@/store/player";
import {NewsPanel} from "@/scenes.ui/news-panel";
import {Tr} from "@/i18n/i18n";

export class ListManualLink extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, manualId: string, linkText: string, height: number) {
        super(scene);

        this.scene = scene;
        this.height = height;

        let link = new BBCodeText(scene, 0, 20, '[color=#C4C4C4][u]' + linkText + '[/u][/color]', {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '13pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 420
            },
            underline: {
                color: '#C4C4C4',
                thickness: 2,
                offset: 2
            }
        });

        link.setOrigin(0.5);
        link.setInteractive().on('pointerup', () => {
            PlayerStore.getManual(manualId).then(man => {
                let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('manual'), man, () => {
                    ip.close();
                });
                ip.openAnimated();
            });
        });

        this.add(link);
    }

}
